module.exports = __webpack_public_path__ + "img/locale1.4998d7a9.png";